import ACustomTemplate from './service';
export default {
    ACustomTemplate
};